module.exports = __webpack_public_path__ + "img/bimb.f0a0adef.png";